import * as update from "immutability-helper";
import { FILE_DELETE_REQUEST, FILE_DELETE_SUCCESS, FILE_DELETE_FAILURE } from "../actions/dashboard.actions";

export type FileState = {
    fileDeleting: boolean
}

const initialState: FileState = {
    fileDeleting: false
};


export default function survey(state: FileState = initialState, action) {
    switch (action.type) {
        case FILE_DELETE_REQUEST:
            return fileDeleting(state, true);
        case FILE_DELETE_SUCCESS:
            return fileDeleting(state, false);
        case FILE_DELETE_FAILURE:
            return fileDeleting(state, false);
    }
    return state;

}

function fileDeleting(state: FileState, loading) {
    return update(state, {
        fileDeleting: { $set: loading }
    })
}